import { z } from 'zod';
import { KBType, KB } from '@/modules/gpt-chats/models/kb';
import { Link, MessageCircleQuestion, File, MessageCirclePlus } from 'lucide-react';

import { TFunction } from 'i18next';

export const getTextKbFormSchema = (t: TFunction) => z.object({
  text: z
    .string()
    .trim()
    .nonempty({ message: t('INFORMATION_REQUIRED') })
    .min(100, t('MIN_100_CHARACTERS_REQUIRED'))
    // .max(10000, "Maximum 10000 characters is allowed")
    .trim(),
});

export type TextKbFormValues = z.infer<ReturnType<typeof getTextKbFormSchema>>;

export const textKbFormDefaultValues: TextKbFormValues = {
  text: '',
};

export const KB_TABS = [
  {
    value: KBType.FILE,
    label: 'FILES',
    icon: File,
  },
  {
    value: KBType.LINK,
    label: 'LINKS',
    icon: Link,
  },
  {
    value: KBType.TEXT,
    label: 'WRITEUPS',
    icon: MessageCirclePlus,
  },
  {
    value: KBType.QnA,
    label: 'Q_AND_A',
    icon: MessageCircleQuestion,
  },
] as const;

export const truncateString = (str: string, num: number) => {
  if (str.length <= num) {
    return str;
  }
  return str.slice(0, num) + '...';
};

export const getKBName = (kb: KB, t: (key: string) => string, maxLength = 50) => {
  if (!kb) return '';

  if (kb.kb_type === KBType.FILE) {
    return kb.file?.name || t('FILE_LABEL');
  } else if (kb.kb_type === KBType.TEXT) {
    return truncateString(kb.text?.content || t('TEXT_CONTENT'), maxLength);
  } else if (kb.kb_type === KBType.QnA) {
    return truncateString(kb.qa?.question || t('Q_AND_A'), maxLength);
  } else if (kb.kb_type === KBType.LINK) {
    return truncateString(kb.link?.url || t('LINK_LABEL'), maxLength);
  }
  return t('DOCUMENT');
};
